import axios from "axios"
import {
	Message,
	Notification
} from 'element-ui'
//退出登录url
// var URL = 'https://oa2.lzjzcz.cn'
//测试环境
// if (process.env.NODE_ENV === 'development') {
	var baseUrl = 'https://rhs.cdwomen.net/prod-api'
	// var baseUrl = 'http://192.168.10.72:8084'
// }
// 线上环境p
// else if (process.env.NODE_ENV === 'production') {
// 	var baseUrl = 'http://192.168.10.101/dev-api'
// }

const instance = axios.create({
	baseURL: baseUrl,
	timeout: 10000,
});
axios.defaults.withCredentials = true
// request拦截器
instance.interceptors.request.use(
	config => {
		// 在发送请求之前做的事情
		config.headers['username'] = sessionStorage.getItem("username")
		config.headers['token'] = sessionStorage.getItem("token")
		return config
	},
	error => {
		// 处理请求错误
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
instance.interceptors.response.use((res) => {
	var status = res.status
	if (status === 200) {
		var data = res.data;
		if (data.code === 201) {
			window.location = 'http://192.168.10.101/dev-api'
		}
		if (data.code === 400) {
			Notification.error({
				title: '请求失败',
				message: data.message,
				duration: 6000
			});
		}
		if (data.code === 500) {
			Message.error(data.message)
		}
		return res;
	}
})
// ,
// err => {
// 	Notification.error({
// 		title: '请求失败',
// 		message: data.message,
// 		duration: 6000
// 	});
// }
export function get(url, data) {
	return new Promise((resolve, reject) => {
		instance({
			url: url,
			method: "GET",
			params: data
		}).then(res => {
			resolve(res.data)
		}).catch(error => {
			reject(error)
		})
	})
}
export function post(url, data) {
	return new Promise((resolve, reject) => {
		instance({
			url: url,
			method: "POST",
			params: data
		}).then(res => {
			resolve(res.data)
		}).catch(error => {
			reject(error)
		})
	})
}
export function json(url, data) {
	return new Promise((resolve, reject) => {
		instance({
			url: url,
			method: "POST",
			data: data
		}).then(res => {
			resolve(res.data)
		}).catch(error => {
			reject(error)
		})
	})
}
/** 下载 **/
export function download(url, data) {
	return new Promise((success, error) => {
		instance({
			url: url,
			method: "GET",
			params: data,
			responseType: 'blob'
		}).then(res => {
			success(res.data)
			if (res.status === 200) {
				// 从返回的headers中拿到文件名称
				let filename = res.headers['content-disposition'].split(';')[1].split('=')[1];
				console.log(filename)
				filename = escape(filename)
				filename = decodeURI(filename)
				let url = window.URL.createObjectURL(new Blob([res.data]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', filename)
				document.body.appendChild(link)
				link.click()
			}
		}).catch(res => {
			error(res)
		})
	})
}
//导出域名
export {
	baseUrl
}
